import React, { useState } from 'react';
import { useOrganisation } from '@/lib/OrganisationContext';

export default function ActAsBanner() {
  const { actingAs, selectedOrg, stopActAs } = useOrganisation();
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState('');
  if (!actingAs) return null;
  async function stop() {
    setBusy(true); setError('');
    try { await stopActAs(); } catch (e) { setError(e.message || 'Could not stop act-as session'); } finally { setBusy(false); }
  }
  return (
    <div role="status" aria-live="polite" className="flex flex-wrap items-center justify-between gap-3 border-b border-amber-300 bg-amber-100 px-4 py-2 text-sm text-amber-950">
      <span className="min-w-0 flex-1 break-words">Acting as <strong>{actingAs.organisation_name || selectedOrg?.name || actingAs.organisation_id}</strong> until {new Date(actingAs.expires_at).toLocaleString('en-GB', { dateStyle: 'medium', timeStyle: 'short' })}.</span>
      <button type="button" onClick={stop} disabled={busy} className="min-h-11 shrink-0 rounded-lg border border-amber-700 px-3 py-1.5 font-semibold hover:bg-amber-200 disabled:opacity-50">{busy ? 'Stopping…' : 'Stop'}</button>
      {error && <span role="alert" className="w-full text-red-800">{error}</span>}
    </div>
  );
}
